import { HtsInputType } from '@evaltick/shared';

/** Admin-facing labels for HtsQuestion.inputType — friendlier than the raw enum names. */
export const HTS_INPUT_TYPE_LABELS: Record<HtsInputType, string> = {
  [HtsInputType.TEXT]: 'Short text',
  [HtsInputType.TEXTAREA]: 'Long text',
  [HtsInputType.DATE]: 'Date',
  [HtsInputType.SELECT]: 'Dropdown (pick one)',
  [HtsInputType.CHECKBOXES]: 'Checkboxes (pick multiple)',
  [HtsInputType.YES_NO]: 'Yes / No',
  [HtsInputType.REPEATABLE_GROUP]: 'Repeatable list (e.g. employment history)',
};
